import { useState, useEffect } from "react";
import { defaultMergedPersonalizedSuggestions } from "../suggestions/defaultSuggestionResponse";
import { getPersonalization } from "./store";
import { IArticleSuggestion, IPersonalizedSuggestions } from "../../types/suggestion-response";
import { isMobileShop } from "../contextDetection";
import { PriceEnum } from "../../types/article-price";

export function usePersonalizedSuggestions() {
    const [personalizedData, setPersonalizedData] = useState<IPersonalizedSuggestions>(
        defaultMergedPersonalizedSuggestions()
    );
    const [isLoading, setIsLoading] = useState(true);
    const [isEnabled, setIsEnabled] = useState(false);

    useEffect(() => {
        getPersonalization().then((result) => {
            setIsEnabled(result.isEnabled);
            const defaultData = defaultMergedPersonalizedSuggestions();

            if (result.isEnabled) {
                const countPerDevice = isMobileShop() ? 5 : 10;

                const mappedData: IPersonalizedSuggestions = {
                    ...defaultData,
                    isSuggestionResponse: false,
                    storedQueries: result.storedQueries,
                    topSearchQueries: result.topSearchQueries.slice(0, countPerDevice),
                    priceMandantSettingsArticles: {
                        currencySymbolWeb: result.currencyInformation.symbol,
                        currencySymbolMobile: result.currencyInformation.symbol,
                        prependCurrencySymbolWeb: result.currencyInformation.prependCurrencySymbol,
                        prependCurrencySymbolMobile:
                            result.currencyInformation.prependCurrencySymbol
                    },
                    articles: result.recommendations.map<IArticleSuggestion>((reco) => {
                        return {
                            title: reco.salesDesignation,
                            image: reco.mainArticleImage,
                            price: {
                                minimalPrice: {
                                    price: reco.priceInformation.minimalPrice.price,
                                    quantity: reco.priceInformation.minimalPrice.quantity,
                                    priceType:
                                        reco.priceInformation.priceType === "from"
                                            ? PriceEnum.From
                                            : PriceEnum.Only
                                },
                                comparisonPrice: reco.priceInformation.comparisonPrice
                                    ? {
                                          price: reco.priceInformation.comparisonPrice.price,
                                          unit: reco.priceInformation.comparisonPrice.unit
                                      }
                                    : undefined,
                                discountPrice: reco.priceInformation.discountPrice
                                    ? {
                                          originalPrice: reco.priceInformation.discountPrice.price,
                                          discountPercentage:
                                              reco.priceInformation.discountPrice.priceDeduction
                                      }
                                    : undefined,
                                quantityUnitPlural: reco.packagingInformation.quantityUnitPlural
                            },
                            url:
                                reco.articleLink +
                                `?itemorigin=RECO_${reco.recommendationType.toUpperCase()}_SEARCH`,
                            shortLink: encodeURIComponent(`article://SA-${reco.salesArticleNo}`),
                            availableColorsCount: reco.availableColors,
                            availableModelsCount: reco.availableModels
                        };
                    })
                };
                setPersonalizedData(mappedData);
            } else {
                setPersonalizedData(defaultData);
            }
            setIsLoading(false);
        });
    }, []);

    return { personalizedData, isLoading, isEnabled };
}
